import {
  config,
  type SanitizeConfig,
} from 'sanitize-text/sanitizers/SanitizeConfiguration';

export const NOTE_SANITIZE_CONFIG: SanitizeConfig = {
  elements: ['p', 'br', 'strong', 'b', 'a', 'ul', 'ol', 'li'],
  attributes: {
    a: ['href', 'target'],
  },
  protocols: {
    a: { href: ['http', 'https', 'mailto'] },
  },
  add_attributes: {
    a: { rel: 'nofollow noopener noreferrer' },
  },
  remove_contents: ['script', 'style'],
};

export const NOTE_DISPLAY_SANITIZE_CONFIG = config.HTML;
